import(/* webpackMode: "eager" */ "/vercel/path0/src/app/EMM/page.tsx");
